import { api } from "@/lib/api";

const KEY = "mb_ref";
const SRC_KEY = "mb_src";
const DAYS_30 = 30 * 24 * 3600 * 1000;

export const captureRef = () => {
  const url = new URL(window.location.href);
  const code = (url.searchParams.get("ref") || "").toLowerCase().replace(/[^a-z0-9]/g, "");
  const src = (url.searchParams.get("src") || "").toLowerCase().replace(/[^a-z0-9]/g, "");
  if (!code && !src) return;
  url.searchParams.delete("ref");
  url.searchParams.delete("src");
  window.history.replaceState(null, "", url.pathname + url.search + url.hash);
  if (code) {
    api.post(`/ref/${code}/click`).then(({ data }) => {
      if (data.valid) localStorage.setItem(KEY, JSON.stringify({ code, ts: Date.now() }));
    }).catch(() => {});
  }
  if (src) {
    api.post(`/src/${src}/scan`).then(({ data }) => {
      if (data.valid) localStorage.setItem(SRC_KEY, JSON.stringify({ src, ts: Date.now() }));
    }).catch(() => {});
  }
};

const read = (key) => {
  try {
    const r = JSON.parse(localStorage.getItem(key) || "null");
    return r && Date.now() - r.ts < DAYS_30 ? r : null;
  } catch { return null; }
};

export const getRef = () => read(KEY)?.code || null;
export const getSrc = () => read(SRC_KEY)?.src || null;
